"use client";
import type { LyricsWithSlug } from "@/types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "~/components/Link";

function AdminLyricsSourceLink({ lyrics }: { lyrics: LyricsWithSlug }) {
  if (!lyrics.source) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, pl: { xs: 1, md: 0 }, flexWrap: "wrap" }}>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          fontSize: "0.875rem"
        }}>
        sursa
      </Typography>
      <Link
        href={lyrics.source}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ fontSize: "0.875rem" }}
      >
        {lyrics.source}
      </Link>
    </Box>
  );
}

export default AdminLyricsSourceLink;